import "./index.scss";
import "../../App.scss";
import { useEffect } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectWidth, selectHeight } from "../../Store/store";
import { redirectFromParams, fetchImage, getSearchParams } from "../nonUIFuncs";
import PropTypes from "prop-types";

// Positions are fractions of screen width/height, mapped to the map.png asset
const TOWN_POSITIONS = {
  Alatna:    { left: 0.453, top: 0.233, width: 0.16,   height: 0.07  },
  Allakaket: { left: 0.628, top: 0.23,  width: 0.22,   height: 0.07  },
  Galena:    { left: 0.325, top: 0.528, width: 0.155,  height: 0.09  },
  Hughes:    { left: 0.34,  top: 0.32,  width: 0.16,   height: 0.071 },
  Huslia:    { left: 0.225, top: 0.397, width: 0.1555, height: 0.073 },
  Kaltag:    { left: 0.193, top: 0.722, width: 0.16,   height: 0.096 },
  Koyukuk:   { left: 0.102, top: 0.535, width: 0.193,  height: 0.067 },
  Manley:    { left: 0.645, top: 0.545, width: 0.134,  height: 0.116 },
  Minto:     { left: 0.793, top: 0.547, width: 0.145,  height: 0.089 },
  Nulato:    { left: 0.0685,top: 0.649, width: 0.162,  height: 0.07  },
  Rampart:   { left: 0.6978,top: 0.453, width: 0.19,   height: 0.083 },
  Ruby:      { left: 0.398, top: 0.619, width: 0.128,  height: 0.093 },
  Tanana:    { left: 0.552, top: 0.426, width: 0.129,  height: 0.115 },
};

const LocationMenu = ({ config }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const width = useSelector(selectWidth);
  const height = useSelector(selectHeight);

  useEffect(() => {
    document.title = `${config.AppName} - Locations`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Synchronous redirects -- must happen before render to avoid flash
  const missingParamRedirect = redirectFromParams(["difficulty"]);
  if (missingParamRedirect.length > 0) {
    return <Navigate to={missingParamRedirect} replace />;
  }

  const params = getSearchParams(location);
  const isChanging = params.some((p) => p.id === "change");
  const savedTown = localStorage.getItem("kz_location");
  if (savedTown && !isChanging) {
    const existingSearch = params
      .filter((p) => p.id !== "change")
      .map((p) => `${p.id}=${p.modifier}${p.value}`)
      .join("&");
    return <Navigate to={`/choose-unit?${existingSearch}&location=${encodeURIComponent(savedTown)}`} replace />;
  }

  const handleTownClick = (townName) => {
    localStorage.setItem("kz_location", townName);
    const cleanParams = params.filter((p) => p.id !== "change");
    const existingSearch = cleanParams
      .map((p) => `${p.id}=${p.modifier}${p.value}`)
      .join("&");
    navigate(`/choose-unit?${existingSearch}&location=${encodeURIComponent(townName)}`);
  };

  return (
    <div className="locationmenu_container all_pages_container">
      {config.dialectStructure.map((town) => {
        const position = TOWN_POSITIONS[town.display];
        if (!position) return null;
        return (
          <div
            key={town.display}
            className="locationmenu_townbutton hovercursor"
            role="button"
            tabIndex={0}
            aria-label={town.display}
            style={{
              backgroundImage: `url(${fetchImage(`${town.display.toLowerCase()}.png`)})`,
              width: width * position.width,
              height: height * position.height,
              left: width * position.left,
              top: height * position.top,
            }}
            onClick={() => handleTownClick(town.display)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleTownClick(town.display);
              }
            }}
          />
        );
      })}
    </div>
  );
};

LocationMenu.propTypes = {
  config: PropTypes.object,
};

export default LocationMenu;
